import BaseError from './BaseError';
export default class BranchExistsError extends BaseError {
    constructor(message, originalError) {
        super(message, originalError);
        this.originalError = originalError;
    }
}
